// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a bho_vu bho_ql bho_va bho_gy bho_kg bho_sv","ProfileAdminTools__item":"iz_b"};